import deepClone from '@mna/utils/deepClone'

export default () => deepClone({
  currentSymptomsMap: {},
  currentSymptomsSortedKeys: [],
  currentSymptomTitles: [],
  symptomSearchResult: [],
  symptomSearchError: false,
  primarySymptom: 0
})
